import React from 'react';
import Day from 'dayjs';
import 'dayjs/locale/es';
import PropTypes from 'prop-types';
import style from './style.scss';//NOSONAR


const Month = ({daySelected}) => {

    const month = Day(daySelected ? daySelected : undefined).locale('es').format('MMMM YYYY');

    return (
        <div className="modal-date-delivery-month-wrapper">
            <h3 className="modal-date-delivery-month" >{month}</h3>
        </div>
    )
}

Month.propTypes = {
    daySelected: PropTypes.string
}

export default Month;
